import { omit } from 'lodash';
import { getQueryString, get, post, put, del } from './utils';

export async function clearCacheApi(data) {
  return del(`/cache/clear?${getQueryString(data)}`);
}

export async function getAddressApi() {
  return get(`/client/address`);
}

export async function getConfigApi() {
  return get(`/config`);
}

export async function getSummariesApi() {
  return get('/dashboards');
}

export async function getRevenueApi(data) {
  return put('/revenue', data);
}

export async function getGlobalSaleApi() {
  return get('/global-sales');
}

export async function getSummariesCustomersApi() {
  return get('/summaries-customers');
}
export async function getPopularProductApi() {
  return get('/popular-product');
}

export async function getPreview(data) {
  return post(`/preview`, data);
}

export async function crawlerPage(data) {
  return post(`/crawlerPage`, data);
}

export async function getLocationsApi(data) {
  return get(`/locations`, data);
}

export async function importLocationsApi(data) {
  return post(`/locations/upsert`, data);
}

export async function importProductCategoriesApi(data) {
  return post(`/product-categories/${data?.type}/products`, omit(data, 'type'));
}

export async function importProductCollectionsApi(data) {
  return post(
    `/product-collections/${data?.type}/products`,
    omit(data, 'type'),
  );
}

export async function importBrandsApi(data) {
  return post(`/brands/${data?.type}/products`, omit(data, 'type'));
}

export async function importProductTypesApi(data) {
  return post(`/product-types/${data?.type}/products`, omit(data, 'type'));
}

export async function getJobStatusApi(id) {
  return get(`/batch/job-status/${id}`);
}

export const getChainStoresApi = () => {
  return get('/chain-stores', {
    limit: 50,
  });
};

export async function getPartnerFiltersApi() {
  return get(`/partners/filter`);
}

export async function getChannelSummaryApi({
  customApiResource,
  status,
  resource = 'orders',
  filter,
}) {
  return get(
    customApiResource ||
      `/${resource}/channel/summary${status ? `/${status}` : ''}`,
    filter,
  );
}

export async function getSummaryOrderDeliveryApi(data) {
  return get(`/summary-order/delivery?statusOms=${data?.status}`);
}

export async function getOrderStatusCountApi() {
  return get(`/summary-order/status-count`);
}

export async function getTransferOrderStatusCountApi() {
  return get(`/summary-transfer/status-count`);
}
